/**
 * SOLID Review
 * S — Strong. One concern: hand the tree the composition root's view-model factory.
 * O — Strong. Nothing here grows with a view model.
 * L — N/A — a component and a hook.
 * I — Strong. A provider and its hook.
 * D — Strong. The factory's type and React's context.
 */
import React, { createContext, useContext, type ReactNode } from 'react';
import type { ViewModelFactory } from './ViewModelFactory';

const ViewModelContext = createContext<ViewModelFactory | null>(null);

interface IPropsViewModelProvider {
  readonly factory: ViewModelFactory;
  readonly children: ReactNode;
}

/** The factory every `useViewModel` below builds from — the composition root's (App.tsx), a test's (the Framework harness). */
export const ViewModelProvider: React.FC<IPropsViewModelProvider> = ({ factory, children }) => (
  <ViewModelContext.Provider value={factory}>{children}</ViewModelContext.Provider>
);

export function useViewModelFactory(): ViewModelFactory {
  const factory = useContext(ViewModelContext);
  if (factory === null) throw new Error('useViewModelFactory must be used within <ViewModelProvider>');
  return factory;
}
